"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setCurrentPathname", {
  enumerable: true,
  get: function get() {
    return _overridesByPathname.setCurrentPathname;
  }
});
Object.defineProperty(exports, "rehydrateOverridesForPathname", {
  enumerable: true,
  get: function get() {
    return _overridesByPathname.rehydrateOverridesForPathname;
  }
});
Object.defineProperty(exports, "preloadOverridesForPathname", {
  enumerable: true,
  get: function get() {
    return _overridesByPathname.preloadOverridesForPathname;
  }
});
Object.defineProperty(exports, "loadOverridesForPathname", {
  enumerable: true,
  get: function get() {
    return _overridesByPathname.loadOverridesForPathname;
  }
});
Object.defineProperty(exports, "_outsmartly_two_promises_settled", {
  enumerable: true,
  get: function get() {
    return _overridesByPathname._outsmartly_two_promises_settled;
  }
});
Object.defineProperty(exports, "OutsmartlyScript", {
  enumerable: true,
  get: function get() {
    return _OutsmartlyScript.OutsmartlyScript;
  }
});
Object.defineProperty(exports, "_outsmartly_enabled", {
  enumerable: true,
  get: function get() {
    return _env._outsmartly_enabled;
  }
});
Object.defineProperty(exports, "_outsmartly_override", {
  enumerable: true,
  get: function get() {
    return _babelOutputHelpers._outsmartly_override;
  }
});
Object.defineProperty(exports, "_outsmartly_mark_return", {
  enumerable: true,
  get: function get() {
    return _babelOutputHelpers._outsmartly_mark_return;
  }
});
Object.defineProperty(exports, "_outsmartly_mark_attr", {
  enumerable: true,
  get: function get() {
    return _babelOutputHelpers._outsmartly_mark_attr;
  }
});
Object.defineProperty(exports, "_outsmartly_mark_child", {
  enumerable: true,
  get: function get() {
    return _babelOutputHelpers._outsmartly_mark_child;
  }
});

var _overridesByPathname = require("./overridesByPathname.js");

var _OutsmartlyScript = require("./OutsmartlyScript.js");

var _env = require("./env.js");

var _babelOutputHelpers = require("./babel-output-helpers.js");
/*globals window, location, self */
// Public API
// Private API
// Initialization Client-side
// TODO(jayphelps): ideally this is done by plugins e.g. our Next plugin.
// Doing it inside on-init-client.js does NOT work.


if (typeof location === 'object' && typeof location.pathname === 'string') {
  (0, _overridesByPathname.rehydrateOverridesForPathname)(location.pathname + location.search);
}

var root = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof global === 'object' ? global : null;

if (root.__ORLY__) {
  throw new Error('More than one copy of the Outsmartly SDK was loaded. Check your node_modules or npm/yarn why for duplicates.');
}

root.__ORLY__ = {};